import React from 'react'

const energyEstimationEquations = [
  { key: 'INSTITUTE_OF_MEDICINE', label: 'Institute of medicine' },
  { key: 'HARRIS_BENEDICT', label: 'Harris-Benedict' },
  { key: 'REVISED_HARRIS_BENEDICT', label: 'Revised Harris-Benedict' },
]

export const EnergyEstimationEquationEditor = ({
  energyEstimationEquation,
  updateEnergyEstimationEquation,
}) => {
  return (
    <div className="form-group">
      <label>
        {energyEstimationEquations.map((equation) => (
          <div key={equation.key}>
            <label>
              <input
                type="radio"
                name="energyEstimationEquation"
                value={equation.key}
                onChange={(evt) => updateEnergyEstimationEquation(equation.key)}
                checked={energyEstimationEquation === equation.key}
              />{' '}
              {equation.label}
            </label>
          </div>
        ))}
      </label>
    </div>
  )
}

export default EnergyEstimationEquationEditor
